<template lang="pug">
  v-dialog(v-model="showWarningDialog" width="500" :fullscreen="$vuetify.breakpoint.smAndDown" scrollable persistent)
    v-card.d-flex.flex-column(flat )
        v-card-title.headline {{ $t('settingsPage.deleteLabel') }}
        v-card-text.pb-1.flex-shrink-0.flex-grow-1.card-body
            v-row(v-if="$vuetify.breakpoint.mdAndUp")
              v-col(cols="12")
                span {{ $t('settingsPage.warningMessageLabel') }} {{tagDetail.title}}?
            v-row.text-center(v-else align="center" )
              v-col(cols="12" align="center")
                span {{ $t('settingsPage.warningMessageLabel') }} {{tagDetail.title}}?
        v-divider
        v-card-actions
          v-spacer
          v-btn(color="primary" text @click="onCancelButtonClick" :disabled="inProgress") {{ $t('addBoarderDialog.closeButtonLabel') }}
          v-btn(color="primary" @click="onSubmitButtonClick" :loading="inProgress") {{ $t('settingsPage.deleteButtonLabel') }}

</template>

<script lang="ts">

import {Component, Prop} from "vue-property-decorator";
import Vue from 'vue';
import Tag from "@/model/tennant/Tag";

@Component({})

export default class WarningDialog extends Vue {

  @Prop({ type: Boolean, default: false }) readonly showWarningDialog!: boolean
  @Prop({ type: Object, required: false }) readonly tagDetail!: Tag

  private inProgress: boolean = false

  onSubmitButtonClick (): void {
    this.$emit('yes')
  }

  onCancelButtonClick (): void {
    this.$emit('close')
  }
}

</script>

<style lang="stylus" scoped>

</style>
